import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  VStack,
  Spinner,
} from '@chakra-ui/react';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useForGetPassword } from '../utils/auth.api';

export default function ForgetPage() {
  const navigate = useNavigate();
  const { mutate: requestOTP, isLoading } = useForGetPassword(); 
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if email is provided
    if (!email) {
      alert('Please enter an email address');
      return;
    }

    // Call the API to request OTP
    try {
      await requestOTP({ email: email });
      toast.success(`OTP sent to ${email}`);
      navigate('/verify-otp', { state: { email: email } });
      
    } catch (err) {
      console.error('Error:', err);
      toast.error(`Failed to send OTP. ${err?.message}`);
    }
  };

  return (
    <Box minH="100vh" bg="white">
      <Container maxW="sm" centerContent>
        <VStack spacing={8} w="100%" pt={12}>
          {/* Header Section */}
          <Box textAlign="left" w="100%">
            <Heading as="h1" size="lg" color="gray.900" fontWeight="bold" lineHeight="1.2" mb={3}>
              Forgot password?
            </Heading>
            <Text color="gray.500" fontSize="sm" lineHeight="1.4">
              Enter your email address and we'll send you confirmation code to reset your password
            </Text>
          </Box>

          {/* Form Section */}
          <VStack as="form" spacing={6} w="100%" onSubmit={handleSubmit}>
            <FormControl>
              <FormLabel color="gray.700" fontWeight="medium">Email Address</FormLabel>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder=""
                size="lg"
                bg="gray.50"
                borderColor="gray.200"
                borderRadius="lg"
                _placeholder={{ color: "gray.600" }}
                isDisabled={isLoading}
              />
            </FormControl>

            {/* Continue Button */}
            <Button
              type="submit"
              w="100%"
              bg="#5A5BED"
              height="50px"
              color="white"
              fontWeight="semibold"
              borderRadius="100px"
              isLoading={isLoading}
              loadingText="Sending..."
              spinner={<Spinner size="sm" color="white" />}
              _hover={{ bg: "#4A4BDD" }}
              mt={{ base: 16, md: 8 }}
            >
              Continue
            </Button>
          </VStack>

          {/* Desktop: show in normal flow */}
          <Box
            display={{ base: "none", md: "block" }}
            pt={4}
            w="100%"
          >
            <Text color="gray.600" textAlign="center">
              Remember your password?{' '}
              <span 
                style={{ color: '#3b82f6', textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => navigate('/sign-in')}
              >
                Sign In
              </span>
            </Text>
          </Box>

          {/* Mobile: fix to bottom */}
          <Box
            display={{ base: "block", md: "none" }}
            position="fixed"
            bottom="0"
            left="0"
            w="100vw"
            bg="white"
            py={4}
            boxShadow="0 -2px 8px rgba(0,0,0,0.03)"
            zIndex={10}
          >
            <Text color="gray.600" textAlign="center">
              Remember your password?{' '}
              <span 
                style={{ color: '#3b82f6', textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => navigate('/sign-in')}
              >
                Sign In
              </span>
            </Text>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
}